<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  import Conexoes from '../Classes/Conexoes.js';
  import Constantes from '../Classes/Constantes.js';
  import LoadingTela from '../componentes_basicos/LoadingTela.svelte';
  import CaixaDeDialogo from '../componentes_basicos/CaixaDeDialogo.svelte';

  let novaSenha = '';
  let confirmarSenha = '';
  let isLoading = false;
  let mensagem = '';
  let sucessoRedefinicao = false;
  let token = '';

  const conexao = new Conexoes();

  onMount(() => {
    // Pega o ?token=... da URL
    const urlParams = new URLSearchParams(window.location.search);
    token = urlParams.get('token');
    
    if (!token) {
      mensagem = "Link inválido ou ausente. Por favor, solicite a redefinição novamente.";
    }
  });

  async function handleRedefinir() {
    if (!token) {
      mensagem = "Não é possível redefinir sem um token válido.";
      return;
    }
    if (!novaSenha || !confirmarSenha) {
      mensagem = "Preencha ambos os campos de senha.";
      return;
    }
    if (novaSenha !== confirmarSenha) {
      mensagem = "As senhas não coincidem!";
      return;
    }

    isLoading = true;
    const url = Constantes.api_acesso.replace('acesso.php', 'redefinir_senha.php');
    const resposta = await conexao.conecta(url, { body: { token, nova_senha: novaSenha } });
    isLoading = false;

    if (resposta?.sucesso) {
      sucessoRedefinicao = true;
      mensagem = resposta.mensagem;
    } else {
      mensagem = resposta?.mensagem || "Erro ao redefinir a senha.";
    }
  }

  function irParaLogin() {
    mensagem = '';
    navigate(Constantes.tela_login);
  }
</script>

<svelte:head>
  <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800&display=swap" rel="stylesheet">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css">
</svelte:head>

<LoadingTela {isLoading} />
<CaixaDeDialogo message={mensagem} button1Label="Ok" button1Action={sucessoRedefinicao ? irParaLogin : () => mensagem = ''} />

<div class="login-wrapper">
  <div class="brand-area fade-in">
    <div class="logo-placeholder"><i class="fas fa-leaf"></i></div>
    <h1>Sistema de Agendamentos</h1>
  </div>

  <div class="login-card fade-in">
    <h3>Criar Nova Senha</h3>
    <p class="subtitle">Digite a sua nova senha de acesso abaixo.</p>

    <form on:submit|preventDefault={handleRedefinir}>
      
      <div class="field-group">
        <label for="senha">Nova Senha</label>
        <div class="input-icon">
          <i class="fas fa-lock"></i>
          <input type="password" id="senha" class="input-modern" bind:value={novaSenha} placeholder="Mínimo 6 caracteres" required />
        </div>
      </div>

      <div class="field-group">
        <label for="confirma_senha">Confirmar Nova Senha</label>
        <div class="input-icon">
          <i class="fas fa-check-circle"></i>
          <input type="password" id="confirma_senha" class="input-modern" bind:value={confirmarSenha} placeholder="Repita a senha" required />
        </div>
      </div>
      
      <button type="submit" class="btn-primary w-100">
        Salvar Nova Senha <i class="fas fa-save ms-2"></i>
      </button>

      <button type="button" class="btn-outline w-100 mt-3" on:click={() => navigate(Constantes.tela_login)}>
        Voltar ao Login
      </button>
    </form>
  </div>
</div>

<style>
  /* Aproveitamos exatamente o mesmo CSS lindo da TelaLogin */
  :root { --primary: #4a6c56; --primary-dark: #3a5443; --accent: #cfaa6c; --text-main: #2c3e34; --text-muted: #738a7c; --border: #e0e6e2; }
  * { box-sizing: border-box; }
  .login-wrapper { min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; background: linear-gradient(135deg, var(--primary) 0%, #2c3e34 100%); font-family: 'Montserrat', sans-serif; padding: 20px; }
  .brand-area { text-align: center; color: white; margin-bottom: 30px; }
  .logo-placeholder { width: 60px; height: 60px; background: var(--accent); color: white; border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 1.8rem; margin: 0 auto 15px auto; box-shadow: 0 4px 15px rgba(207, 170, 108, 0.4); transform: rotate(10deg); }
  .brand-area h1 { margin: 0; font-size: 1.5rem; font-weight: 800; letter-spacing: 0.5px; }
  .login-card { background: #fff; padding: 40px 35px; border-radius: 16px; width: 100%; max-width: 420px; box-shadow: 0 15px 50px rgba(0,0,0,0.3); border-bottom: 5px solid var(--accent); }
  .login-card h3 { margin: 0 0 5px 0; color: var(--primary); font-size: 1.6rem; font-weight: 800; }
  .subtitle { color: var(--text-muted); font-size: 0.9rem; margin-bottom: 30px; }
  .field-group { margin-bottom: 20px; display: block; width: 100%; }
  .field-group label { display: block; font-size: 0.85rem; font-weight: 700; color: var(--text-main); margin-bottom: 8px; text-align: left; }
  .input-icon { position: relative; display: flex; align-items: center; }
  .input-icon i { position: absolute; left: 15px; color: var(--text-muted); font-size: 1rem; }
  .input-modern { width: 100%; padding: 14px 15px 14px 45px; border: 1px solid var(--border); border-radius: 8px; font-family: inherit; font-size: 1rem; color: var(--text-main); background: #fdfdfd; transition: all 0.2s; }
  .input-modern:focus { outline: none; border-color: var(--primary); background: white; box-shadow: 0 0 0 3px rgba(74, 108, 86, 0.1); }
  .w-100 { width: 100%; } .ms-2 { margin-left: 8px; } .mt-3 { margin-top: 15px; }
  .btn-primary { background: var(--primary); color: white; border: none; padding: 15px; border-radius: 8px; font-weight: 700; font-size: 1.05rem; cursor: pointer; transition: background 0.3s, transform 0.2s; margin-top: 10px; }
  .btn-primary:hover { background: var(--primary-dark); transform: translateY(-2px); }
  .btn-outline { background: transparent; color: var(--primary); border: 2px solid var(--border); padding: 12px; border-radius: 8px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: all 0.2s; }
  .btn-outline:hover { background: #f4f7f5; border-color: var(--primary); }
  .fade-in { animation: fadeIn 0.4s ease-in-out; }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }

  @media (max-width: 768px) {
    .login-wrapper {
      justify-content: flex-start;
      padding: 32px 16px;
    }

    .brand-area {
      margin-bottom: 20px;
    }

    .login-card {
      padding: 28px 20px;
      border-radius: 14px;
    }
  }
</style>